import { SelectListOption } from "@/types/common.type";
import * as Constants from "./constants";

export default class EnumExtension {
  protected constructor(public readonly value: string) {}

  static registerEnums(): void {
    Object.values(Constants).forEach((exportedItem) => {
      if (typeof exportedItem === "function" && exportedItem.prototype instanceof EnumExtension) {
        EnumExtension.addEnumBehavior(exportedItem);
      }
    });
  }
  
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  static addEnumBehavior(enumClass: any): void {
    Object.keys(enumClass).forEach((key) => {
      const instance = enumClass[key];

      enumClass[key] = new Proxy(instance, {
        get(target, prop) {
          if (prop === Symbol.toPrimitive || prop === 'value') {
            return target.value;
          }

          return target[prop];
        }
      });
    });
  }

  toString(): string {
    return this.value;
  }

  getId(options: SelectListOption[]): number | null {
    return options.find(option => option.identifier === this.value)?.value ?? null;
  }
}